<template>
  <div class="ButtonFixedAction mobileOnly" :class="{'notAvailable': !productShippingInfo.available}" ref="buttonFixed">
    <ProgressBar></ProgressBar>
    <div class="ButtonFixedAction-container">
      <p v-if="text" class="ButtonFixedAction-text">{{ text }}</p>
      <p v-else class="ButtonFixedAction-text">TOTAL</p>
      <CartPrice
        :originalPrice="originalPrice"
        :specialPrice="specialPrice"
        :ecoTaxe="ecoTaxe"
      ></CartPrice>
    </div>
    <div class="ButtonFixedAction-submit">
      <ProgessButton v-if="isProgressButton" @checkout="$emit('checkout')" :hiddenButton="false"></ProgessButton>
      <a v-else-if="isCartSubmitButton" :href="url"
        ><button class="Button Button-danger">Commander</button></a
      >
      <ButtonProduct v-else></ButtonProduct>
    </div>
  </div>
</template>

<script>
import ProgressBar from "@/components/ProgressBar/ProgressBar.vue";
import CartPrice from "@/includes/Cart/CartPrice/CartPrice-zeborne.vue";
import ProgessButton from "@/components/ProgressButton/ProgressButton.vue";
import ButtonProduct from "@/components/ButtonProduct/ButtonProduct.vue";
import { mapGetters } from "vuex";

import "@/components/ButtonFixedAction/ButtonFixedAction.scss";

export default {
  name: "ButtonFixedAction",
  components: {
    ProgressBar,
    CartPrice,
    ProgessButton,
    ButtonProduct,
  },

  data() {
    return {
      url: process.env.VUE_APP_URL_PREFIX + '/checkout/onepage',
    }
  },

  props: {
    originalPrice: {
      type: [String, Number],
      required: true,
    },
    specialPrice: {
      type: [String, Number],
      required: false,
    },
    ecoTaxe: {
      type: [String, Number],
      required: true,
    },
    text: {
      type: [String],
      required: false,
    },
    isProgressButton: {
      type: Boolean,
      default: false,
      required: false,
    },
    isCartSubmitButton: {
      type: Boolean,
      default: false,
      required: false,
    },
    actionName: {
      type: String,
      required: false,
    },
  },

  mounted() {
    const nodeBody = document.getElementsByTagName("body");
    nodeBody[0].style.paddingBottom = this.$refs.buttonFixed.clientHeight + "px";
  },

  computed: {
   ...mapGetters({productShippingInfo: "getProductShippingInfo"}),
  },
};
</script>
